import { lazy, Suspense } from "react";

// Same lazy-chunk pattern as income/components/IncomeChart.js — defers
// recharts+d3 until after hydration. Used by StatCard for its optional
// sparkline slot.
const SparklineImpl = lazy(() =>
  import("./Sparkline.impl").then((m) => ({ default: m.Sparkline }))
);

const Sparkline = (props) => (
  <Suspense fallback={null}>
    <SparklineImpl {...props} />
  </Suspense>
);

export default Sparkline;
